<template>
  <Page class="queryView">
    <div class="queryView-main">
      <div style="display:flex">
        <a-form class="flex-form" style="flex: 1" layout="inline" :form="form" :colon="false">
          <div class="grid grid-cols-2 xl:grid-cols-3">
            <a-form-item label="时间">
              <a-date-picker format="YYYY-MM-DD" @change="onChange" />
            </a-form-item>
          </div>
        </a-form>
        <div style="text-align: right">
          <a-button class="app-btn" type="default" @click="handleAdd">添加汇率</a-button>
        </div>
      </div>
      <p style="margin-top:20px;margin-bottom:-10px;color:red">1美元/韩元折合人民币汇率</p>
      <a-table
        class="mt-5"
        :row-key="
          (record, index) => {
            return index
          }
        "
        bordered
        :loading="tableLoading"
        :columns="tableColumns"
        :dataSource="dataSource"
        @change="handleTableChange$qv"
        :scroll="{ x: 1400 }"
        :pagination="{
          current: pageNumber,
          pageSize: limit,
          total: countTotal,
          showSizeChanger: true,
          showQuickJumper: true,
        }"
      />
    </div>
    
    <a-modal :visible="addGuideType" :title="modalTitle" @ok="submit" @cancel="handleCancel">
      <div>
        <a-form :form="form">
          <a-form-item label="时间周期">
            <!-- <a-input v-decorator="['time', { rules: [{ required: true, message: '请选择时间周期' }] }]" /> -->
            <a-range-picker
              format="YYYY-MM-DD"
              v-decorator="['time', { rules: [{ required: true, message: '请选择时间周期' }] }]"
            />
          </a-form-item>
          <a-form-item label="美元汇率">
            <a-input v-decorator="['usdExchange', { rules: [{ required: true, message: '请输入美元汇率' }] }]" />
          </a-form-item>
          <a-form-item label="韩元汇率">
            <a-input v-decorator="['krwExchange', { rules: [{ required: true, message: '请输入韩元汇率' }] }]" />
          </a-form-item>
        </a-form>
      </div>
    </a-modal>
    <a-modal :visible="codeUrlType" title="绑定微信" @cancel="handleCancel(1)">
      <div
        v-if="codeUrl"
        style="width: 100%;display:flex;justify-content: center;align-items: center;flex-direction: column;"
      >
        <img :src="codeUrl" style="width:200px;height:200px" alt="" />
      </div>
    </a-modal>
  </Page>
</template>

<script>
import Page from '@/components/Page'
import { queryViewMixin, toolMixin } from '@/utils/mixin'

export default {
  mixins: [queryViewMixin, toolMixin],
  data() {
    const tableColumns = [
      {
        title: '序号',
        width: '10%',
        align: 'center',
        customRender: (text, row, index) => {
          return <span>{this.limit * (this.pageNumber - 1) + (index + 1)} </span>
        },
      },
      {
        title: '时间周期',
        align: 'center',
        dataIndex: '',
        customRender: (text, row) => {
          return (
            <span>
              {row.startTime} 至 {row.endTime}
            </span>
          )
        },
      },
      {
        title: '美元汇率',
        align: 'center',
        dataIndex: 'usdExchange',
      },
      {
        title: '韩元汇率',
        align: 'center',
        dataIndex: 'krwExchange',
      },
      {
        title: '操作',
        width: '12%',
        align: 'center',
        customRender: (text, row) => {
          return (
            <div class="flex justify-center gap-5 text-primary-500">
              <a
                class="text-primary-500"
                onClick={() => {
                  this.checkRow(row, 'edit')
                }}
              >
                修改
              </a>
              <a
                onClick={() => {
                  this.handleDel(row)
                }}
              >
                删除
              </a>
            </div>
          )
        },
      },
    ]
    return {
      modalTitle: '添加汇率',
      // labelCol: { style: { width: '100px' } },
      id: null,
      pageNumber: 1,
      limit: 10,
      countTotal: 0,
      codeUrlType: false,
      tableLoading: false,
      addGuideType: false,
      time: null,
      codeUrl: '',
      tableColumns: tableColumns,
      dataSource: [],
      form: this.$form.createForm(this),
      typeList: [
        { label: 'API', value: 1 },
        { label: 'H5', value: 2 },
        { label: '小程序', value: 3 },
      ],
    }
  },
  components: {
    Page,
  },
  async mounted() {
    this.doQuery()
  },
  methods: {
    onChange(date, dateString) {
      console.log(date)
      console.log(dateString)
      this.time = dateString
      this.doQuery()
    },
    async bindCode(row) {
      if (!row.userId) {
        const res = await this.$axios.post(`/guide/admin/guide/generateCodeTouristGuide/${row.id}`)
        if (res.success) {
          this.codeUrl = res.data
        }
        this.codeUrlType = true
      } else {
        this.$confirm({
          title: '解除绑定确认',
          content: '您确认解除绑定导游?',
          onOk: async () => {
            const res = await this.$axios.delete(`/guide/admin/guide/unBindTouristGuide/${row.id}`)
            if (res.success) {
              this.$message.success('解除绑定成功')
              this.doQuery()
            }
          },
          onCancel: () => {
            // reject(new Error('E_CANCEL'))
          },
        })
      }
    },
    submit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          const params = values
          console.log('params', params)
          if (params.time) {
            params.startTime = params.time[0] ? `${params.time[0].format('YYYY-MM-DD HH:mm:ss')}` : ''
            params.endTime = params.time[1] ? `${params.time[1].format('YYYY-MM-DD HH:mm:ss')}` : ''
            params.id = this.id
          }
          let res = null
          if (this.modalTitle == '添加汇率') {
            res = await this.$axios.post('/guide/admin/rmbExchangeRate/add', params)
          } else {
            res = await this.$axios.put('/guide/admin/rmbExchangeRate/edit', params)
          }
          console.info('success', res)
          if (res && res.success) {
            this.addGuideType = false
            this.doQuery()
            this.id = null
          }
        }
      })
    },
    handleCancel(e) {
      this.addGuideType = false
      this.codeUrlType = false
      if (e) {
        this.doQuery()
      }
    },
    async doQuery(_page = this.pageNumber, _limit = this.limit) {
      this.tableLoading = true
      const res = await this.$axios.get('/guide/admin/rmbExchangeRate/getList', {
        params: {
          page: _page,
          limit: _limit,
          time: this.time,
        },
      })
      this.countTotal = Number(res.count)
      this.dataSource = res.data
      this.tableLoading = false
    },
    async handleAdd() {
      this.modalTitle = '添加汇率'
      this.form.resetFields()
      this.addGuideType = true
    },
    async checkRow(row) {
      this.modalTitle = '编辑汇率'
      row.time = [this.$moment(row.startTime), this.$moment(row.endTime)]
      console.log('row', row)
      this.id = row.id
      this.$nextTick(() => {
        this.safeSetFieldsValue$t(this.form, row)
      })
      this.addGuideType = true
    },
    async handleDel(row) {
      this.$confirm({
        title: '删除确认',
        content: '您确认删除当前汇率?',
        onOk: async () => {
          const res = await this.$axios.delete(`/guide/admin/rmbExchangeRate/delete/${row.id}`)
          if (res.success) {
            this.$message.success('删除成功')
            this.doQuery()
          }
        },
        onCancel: () => {
          // reject(new Error('E_CANCEL'))
        },
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
